import React, { useState, useEffect } from "react"
import { Button, Typography, Box, IconButton } from "@mui/material"
import useCamera from "../../../hooks/UseCamera"
import { FormDatasSubmission } from "../../../api/FormData/FormDataSubmissionApi"
import { useNavigate, useLocation } from "react-router-dom"
import Header from "../../Layouts/AppHeader/AppHeader"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"

const CaptureImage: React.FC = () => {
    const { videoRef, canvasRef, startCamera, captureImage } = useCamera()
    const [imagePreview, setImagePreview] = useState<string | null>(null)
    const [fileId, setFileId] = useState<string | null>(null)
    const [isUploadSuccessful, setIsUploadSuccessful] = useState<boolean>(false)

    const navigate = useNavigate()
    const location = useLocation()
    const mobileNumber = location.state?.mobileNumber

    useEffect(() => {
        startCamera()
    }, [startCamera])

    const handleCapture = () => {
        const image = captureImage()
        if (image) {
            setImagePreview(image)
            const file = dataURLtoFile(image, "captured-image.png")
            uploadFile(file)
        }
    }

    const uploadFile = async (file: File) => {
        try {
            const response =
                await FormDatasSubmission.api.mediaUploadFileId(file)
            setFileId(response.data.fileId)
            setIsUploadSuccessful(true)
            console.log(
                "File uploaded successfully, fileId:",
                response.data.fileId
            )
        } catch (error) {
            console.error("Error uploading file", error)
            setIsUploadSuccessful(false)
        }
    }

    const handleRetry = () => {
        setImagePreview(null)
        setFileId(null)
        startCamera()
        setIsUploadSuccessful(false)
    }

    const dataURLtoFile = (dataurl: string, filename: string): File => {
        const arr = dataurl.split(",")
        const mime = arr[0].match(/:(.*?);/)![1]
        const bstr = atob(arr[1])
        let n = bstr.length
        const u8arr = new Uint8Array(n)
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], filename, { type: mime })
    }

    const redirectToForm = () => {
        if (fileId) {
            navigate(`/user-form`, {
                state: {
                    fileId,
                    mobileNumber,
                    visitorName: location.state?.fetchedData?.visitorName,
                    govtIdType: location.state?.fetchedData?.govtIdType,
                    govtIdNumber: location.state?.fetchedData?.govtIdNumber,
                    photoId: location.state?.fetchedData?.photoId,
                    address: location.state?.fetchedData?.address,
                },
            })
        }
    }

    const handleBackClick = () => {
        navigate(-1) // Navigate back to the previous page
    }

    return (
        <>
            <Header />
            <div className="px-12 box-content">
                <div className="flex flex-row items-center justify-center gap-4">
                    <IconButton
                        onClick={handleBackClick}
                        sx={{ width: 10, aspectRatio: 1 / 1 }}
                    >
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </IconButton>
                    <Typography variant="h4" gutterBottom sx={{ flexGrow: 1 }}>
                        Visitor Image
                    </Typography>
                </div>
                <div className="flex flex-col justify-center items-center w-full">
                    <div className="flex flex-col w-fit">
                        <Box
                            sx={{
                                height: "350px",
                                minWidth: 500,
                                mx: "auto",
                                overflow: "hidden", // Ensure content doesn't overflow
                            }}
                        >
                            {imagePreview ? (
                                <img
                                    src={imagePreview}
                                    alt="Captured"
                                    style={{
                                        height: "100%",
                                        objectFit: "cover",
                                    }}
                                />
                            ) : (
                                <>
                                    <video
                                        ref={videoRef}
                                        height="100%"
                                        width={"100%"}
                                        autoPlay
                                        muted
                                        style={{
                                            visibility: imagePreview
                                                ? "hidden"
                                                : "visible",
                                            objectFit: "cover", // Ensure video covers the area
                                        }}
                                    />
                                    <canvas
                                        ref={canvasRef}
                                        style={{ display: "none" }}
                                    />
                                </>
                            )}
                        </Box>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                width: "100%",
                                gap: 2,
                            }}
                        >
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={handleRetry}
                                disabled={!imagePreview}
                                sx={{ width: "100%" }}
                            >
                                Retry
                            </Button>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: "#3ea787",
                                    width: "100%",
                                }}
                                onClick={
                                    imagePreview && isUploadSuccessful
                                        ? redirectToForm
                                        : handleCapture
                                }
                                disabled={
                                    !!imagePreview && !isUploadSuccessful
                                }
                            >
                                {imagePreview ? "Continue" : "Capture Image"}
                            </Button>

                        </Box>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CaptureImage